import { useEffect, useRef, useState } from "react";
import api from "./api";

function merge(saved, defKeys) {
  const s = (saved || []).filter((k) => defKeys.includes(k));
  defKeys.forEach((k) => { if (!s.includes(k)) s.push(k); });
  return s;
}

// Per-user, per-tenant persisted column ordering for a table.
export function useColumnOrder(table, defaultCols) {
  const defKeys = defaultCols.map((c) => c.key);
  const defRef = useRef(defKeys);
  defRef.current = defKeys;
  const [order, setOrder] = useState(defKeys);
  const [edit, setEdit] = useState(false);
  const drag = useRef(null);

  useEffect(() => {
    let on = true;
    api.get(`/table-config/${table}`, { silent: true })
      .then((r) => { if (on) setOrder(merge(r.data.order, defRef.current)); })
      .catch(() => {});
    return () => { on = false; };
  }, [table]);

  const persist = (next) => {
    setOrder(next);
    api.put(`/table-config/${table}`, { data: { order: next } }).catch(() => {});
  };
  const dragStart = (i) => { drag.current = i; };
  const drop = (i) => {
    const f = drag.current;
    if (f === null || f === undefined || f === i) return;
    const next = [...order];
    const [m] = next.splice(f, 1);
    next.splice(i, 0, m);
    drag.current = null;
    persist(next);
  };
  const reset = () => persist(defRef.current.slice());

  const orderedCols = order.map((k) => defaultCols.find((c) => c.key === k)).filter(Boolean);
  return { orderedCols, edit, setEdit, dragStart, drop, reset };
}
